/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * End-of-life intent set on an active recurring leaderboard via the schedule-end endpoint. AFTER_NEXT_CLOSE completes the board after the next period close (full payout + snapshot run first); ON_DATE completes at the first period close on or after scheduledEndAt.
 * @export
 */
export const LeaderboardEndIntent = {
    AFTER_NEXT_CLOSE: 'AFTER_NEXT_CLOSE',
    ON_DATE: 'ON_DATE'
} as const;
export type LeaderboardEndIntent = typeof LeaderboardEndIntent[keyof typeof LeaderboardEndIntent];


export function instanceOfLeaderboardEndIntent(value: any): boolean {
    for (const key in LeaderboardEndIntent) {
        if (Object.prototype.hasOwnProperty.call(LeaderboardEndIntent, key)) {
            if (LeaderboardEndIntent[key as keyof typeof LeaderboardEndIntent] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeaderboardEndIntentFromJSON(json: any): LeaderboardEndIntent {
    return LeaderboardEndIntentFromJSONTyped(json, false);
}

export function LeaderboardEndIntentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardEndIntent {
    return json as LeaderboardEndIntent;
}

export function LeaderboardEndIntentToJSON(value?: LeaderboardEndIntent | null): any {
    return value as any;
}

export function LeaderboardEndIntentToJSONTyped(value: any, ignoreDiscriminator: boolean): LeaderboardEndIntent {
    return value as LeaderboardEndIntent;
}

